export enum LOCAL_STORAGE_KEYS {
  // @deprecated: remove USER_TOKEN when removing all useless integration tests
  USER_TOKEN = "USER_TOKEN",
  AUTH_STORAGE = "auth-storage",
}
